import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import LayoutDefault from '../../components/LayoutDefault';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import PageTitle from '../../components/PageTitle';
import FormLogin from '../../components/FormLogin';
var LoginTemplate = function LoginTemplate(_ref) {
  var headerProps = _ref.headerProps,
    footerProps = _ref.footerProps,
    layoutProps = _ref.layoutProps,
    pageTitleProps = _ref.pageTitleProps,
    formLoginProps = _ref.formLoginProps;
  return /*#__PURE__*/React.createElement(LayoutDefault, _extends({}, layoutProps, {
    header: /*#__PURE__*/React.createElement(Header, headerProps),
    title: /*#__PURE__*/React.createElement(PageTitle, pageTitleProps),
    content: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FormLogin, formLoginProps)),
    footer: /*#__PURE__*/React.createElement(Footer, footerProps)
  }));
};
export default LoginTemplate;